<template>
  <div id="purpleheader" class="ui basic segment" style="padding:0">
    <div class="ui container" style="display:flex;margin:0 auto">
      <div style="display:flex">
        <button class="ui circular icon button" id="backbutton" @click="$router.go(-1)" style="margin-top:auto;margin-bottom:auto" v-if="this.$route.name != 'dashboard' && this.$route.name != 'login' && this.$route.name != 'logout'"><i class="left arrow icon"></i></button>
      </div>
      <img src="/img/icons/24x7.logo.white.svg" class="ui logo image">
      <div style="display:flex" v-if="updateShow">
        <span style="color:white; margin-top:auto;margin-bottom:auto">New version is available.</span>
      </div>
      <div style="display:flex">
        <button class="ui button" @click="reloadPage()" style="margin-top:auto;margin-bottom:auto" v-if="this.$route.name === 'dashboard'">Reload</button>
        <!-- <button class="ui button" @click="deleteDB()" style="margin-top:auto;margin-bottom:auto" v-if="this.$route.name === 'dashboard'">Delete OLDB</button> -->
      </div>
      <div style="clear:both"></div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'MainmenuBar',
    data() {
      return {
        online:true,
        updateShow:false,
        oljobs:0
      }
    },
    mounted() {
      document.addEventListener('serviceWorkerUpdateEvent', this.updateAvailable, { once: true })
      window.addEventListener('online', this.updateOnlineStatus);
      window.addEventListener('offline', this.updateOfflineStatus);
    },
    beforeUnmount() {
      window.removeEventListener('online', this.updateOnlineStatus);
      window.removeEventListener('offline', this.updateOfflineStatus);
    },
    methods:{
      updateOnlineStatus() {
        this.online = true;
      },
      updateOfflineStatus() {
        this.online = false;
      },
      updateAvailable() {
        this.updateShow = true;
      },
      deleteDB() {
        const DBDeleteRequest = window.indexedDB.deleteDatabase("TFSPWAPostDB");
        DBDeleteRequest.onerror = () => {
          console.error("Error deleting database.");
          const DBOpenRequest = window.indexedDB.open("TFSPWAPostDB");
          DBOpenRequest.onupgradeneeded = (event) => {
            const db = event.target.result;
            // if (event.oldVersion < 4) {
              db.createObjectStore("postrequests", {
                keyPath: "id",
              });
            // }
          };
        };

        DBDeleteRequest.onsuccess = () => {
          console.log("Database deleted successfully");

          const DBOpenRequest = window.indexedDB.open("TFSPWAPostDB");
          DBOpenRequest.onupgradeneeded = (event) => {
          const db = event.target.result;
            db.createObjectStore("postrequests", {
              keyPath: "id",
            });
          };
        };
        // return swRegistration.sync.register('myFirstSync');
        
        DBDeleteRequest.onupgradeneeded = () => {
          console.log('on upgrade needed');
        }
      },
      reloadPage(){
        
        navigator.serviceWorker.getRegistration().then(reg=>{reg.unregister()});
        location.reload(true);
      }
    }
  }
  
</script>

